import React from 'react';
import { FieldLabel } from '@measured/puck';
import CustomTooltip from '../../../components/common/tooltip';
import { ToggleButton, ToggleButtonGroup } from '@mui/material';
import { IDefaultOption } from '../../../page-builder/interface/customerInterface';
import { toolTipInfo } from '../../../page-builder/utils/constants';

interface ToggleProps<T> {
  value: T;
  onChange: (_value: T) => void;
  options: IDefaultOption[];
  heading?: IDefaultOption;
  propName: string;
  defaultValue?: string;
  hideHeading?: boolean;
}

const Toggle = <T extends object>({
  value,
  onChange,
  options,
  heading,
  propName,
  defaultValue,
  hideHeading = false,
}: ToggleProps<T>) => {
  const toggleGroup = (
    <ToggleButtonGroup
      value={(value?.[propName as keyof T] as string) || defaultValue}
      exclusive
      className="w-full"
      onChange={(_e, selectValue) =>
        selectValue && onChange({ ...value, [propName]: selectValue })
      }
      aria-label={heading?.value}>
      {options.map((option, index: number) => (
        <ToggleButton
          key={index}
          size="small"
          value={option.value}
          disableRipple
          aria-label={option.value}
          className="flex-1">
          {option.label}
        </ToggleButton>
      ))}
    </ToggleButtonGroup>
  );
  if (hideHeading) {
    return toggleGroup;
  }
  return (
    <FieldLabel
      label={
        (
          <CustomTooltip title={heading?.value as keyof typeof toolTipInfo}>
            <span>{heading?.label}</span>
          </CustomTooltip>
        ) as React.ReactNode as string
      }
      el="div">
      {toggleGroup}
    </FieldLabel>
  );
};

export default Toggle;
